import { render } from "./WorkPerson.vue?vue&type=template&id=784f260c"
import script from "./WorkPerson.vue?vue&type=script&lang=js"
export * from "./WorkPerson.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__